import { Component, Vue, Ref } from "vue-property-decorator";
import LeftTree from '../components/LeftTree.vue'
import AlarmBody from './components/AlarmBody'
import './components/alarm.less'
import { StatisticsServiceProxy,AlarmStatisticsDTO } from '@/service-proxies/app-v2/mdc.service-proxies'
import { exportAlarm } from '@/api/api';
const stsp = new StatisticsServiceProxy()
@Component({
  components: {
    LeftTree,
    AlarmBody
  }
})
export default class Alarm extends Vue {
  @Ref() alarmBody: AlarmBody
  operationData = []
  tabsdData = []
  columns = ['s1','s2','s3','s4','s5','s6','s7','s8','s9']
  searchData = {}
  loading = false
  searchValue:any = {}

  getTableList(value) {
    this.loading = true
    this.operationData = []
    const data = {
      ...value,
      date: value.date,
      shiftIndex: value.shiftIndex,
      shiftIndexs: value.shiftIndexs,
      shiftList: value.shiftList,
      statisticalMethod: value.statisticalMethod,
      workStationList: value.workStationList
    }
    delete(data.title)
    this.searchData = data
    stsp.alarmStatistics(data).then(res =>{
      let arr = [];  
      for(var i=0; i<data.workStationList.length; i++) {
        for(var j=0; j<res.items.length; j++) {
          if(data.workStationList[i].key == res.items[j].workStation.workStationId) {
            arr.push(res.items[j])
          }
        }
      } 

      // this.operationData = res.items
      this.operationData = arr

      this.loading = false
    })
  }
  search(value) {
    delete value.productivityType
    this.searchValue = {...value}
    stsp.splitFilter(value).then(res =>{      
      this.tabsdData = (res.items).reverse()
      this.alarmBody.defaultActiveKey = 0
      if(res.items){
        this.getTableList(this.tabsdData[0])
      }
    })
  }

  handleChange(value){
    this.tabsdData.forEach((res,index) =>{
      if (index === value){
        this.getTableList(res)
      }
    })
  }

  export(){
    const dataList = []
    const weekList = []
    const monthList = []
    const yearList = []
    this.tabsdData.forEach(res =>{
      if(dataList.indexOf(res.date) === -1){
        dataList.push(res.date)
      }
      if(weekList.indexOf(res.week) === -1){
        weekList.push(res.week)
      }
      if(monthList.indexOf(res.month) === -1){
        monthList.push(res.month)
      }
      if(yearList.indexOf(res.year) === -1){
        yearList.push(res.year)
      }
    })
    const value = {
      date: dataList.reverse(),
      month: monthList.reverse(),
      shiftList: this.searchValue.shiftList,
      statisticalMethod: this.searchValue.statisticalMethod,
      week: weekList.reverse(),
      workStationList: this.searchValue.workStationList,
      year: yearList.length > 0 ? (yearList.reverse())[0] : 0
    }
    exportAlarm(value).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_mdc_alarm')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  outPut() {

  }
  changeX(){

  }
  leftTree() {
    return (
      <left-tree init={['statistical','shift','time','Tree.vue']} onSearch={value => this.search(value)} onOutPut={() => this.outPut()} queryKey="bjxx-alerm"></left-tree>
    )
  }
  alarm() {
    return (
      this.operationData ? <alarm-body ref="alarmBody" onExport={() => this.export()} loading={this.loading} searchData={this.searchData} tabsdData={this.tabsdData} data={this.operationData} columns={this.columns} onChangeTabs={value => this.handleChange(value)}></alarm-body> : null
    )
  }
  render() {
    return (
      <a-layout class="alarm-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          {this.alarm()}
        </a-layout-content>
      </a-layout>
    )
  }
}
